import React, { useContext } from 'react';

import WidgetContext from '@totem/components/customDashboard/home/widgets/WidgetContext';
import EventsContainer, {
  containerConfiguration,
} from '@totem/components/services/threats/eventsContainer/EventsContainer';
import EventsTable from '@totem/components/services/threats/eventsContainer/EventsTable';
import InputContainer from '@totem/components/ui_components/reportSettings/InputContainer';
import RecordCountBadge from '@totem/components/ui_components/widgets/RecordCountBadge';

const WidgetEventsReport = () => {
  const { onSetTitle, componentInstance } = useContext(WidgetContext);

  return (
    <InputContainer
      componentKey={`${componentInstance.componentInstanceId}`}
      componentLabel={`Dashboard: ${componentInstance.title}`}
      filterConfig={containerConfiguration}
      defaultSort={{
        field: 'eventTime',
        direction: 'descend',
      }}
    >
      <EventsContainer
        onRecordTotalChanged={(recordCount: number) =>
          onSetTitle(<RecordCountBadge count={recordCount} />)
        }
      >
        <EventsTable />
      </EventsContainer>
    </InputContainer>
  );
};

export default WidgetEventsReport;
